/**
 * Created by cedricgodefroy on 23/08/2017.
 */
angular.module('FlexyBeautyApp.services').factory('SimpleReportDataSource', [function () {

    var SimpleReportDataSource = function () {
        var dataSource = null;
        this.currentPeriod = null;
        this.dateDisplayed = null;
        this.primaryDatasByCategory = new Array();

        this.initReportDataSource();
    };

    SimpleReportDataSource.prototype.initReportDataSource = function () {

    };

    SimpleReportDataSource.prototype.loadDataSource = function (dataSource, currentPeriod, dateDisplayed) {
        this.dataSource = dataSource;
        this.currentPeriod = currentPeriod;
        this.dateDisplayed = dateDisplayed;
    };

    return SimpleReportDataSource;
}]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/report/SimpleReportDataSource.js